const STORAGE_KEY = "5x_assessment_ux_mode";

export const ASSESSMENT_UX_GUIDE = "guide";
export const ASSESSMENT_UX_FORM = "form";

export function readAssessmentUxMode() {
  try {
    const raw = window.localStorage?.getItem(STORAGE_KEY);
    if (raw === ASSESSMENT_UX_FORM || raw === ASSESSMENT_UX_GUIDE) return raw;
  } catch {
    /* ignore */
  }
  return ASSESSMENT_UX_GUIDE;
}

export function writeAssessmentUxMode(mode) {
  const next =
    mode === ASSESSMENT_UX_FORM ? ASSESSMENT_UX_FORM : ASSESSMENT_UX_GUIDE;
  try {
    window.localStorage?.setItem(STORAGE_KEY, next);
  } catch {
    /* ignore */
  }
  return next;
}
